import template from './oneLineText.html';

export default {
  template,
  bindings: {
    content: '<',
    customClass: '<',
  },
};
